import { useCallback, useRef } from 'react';

import { setScrollCoordinates } from '@/apps/mwd-v2/state/actions/scrollCoordinates';
import useClientState from '@/state/useClientState';

import useTooltipActions from '../../state/actions/useTooltipActions';

const useMwdChart = () => {
  const { setTooltipTimeoutId } = useTooltipActions();
  const mwdHeight = useClientState((state) => state.mwd.height);
  const mwdWidth = useClientState((state) => state.mwd.width);
  const mwdWidthPerHour = useClientState((state) => state.mwd.widthPerHour);
  const showTooltip = useClientState((state) => state.tooltip.show);
  const setWeekday = useClientState((state) => state.setWeekday);
  /** Store the scrollLeft to prevent state updates on vertical scroll */
  const scrollLeftRef = useRef<number>(0);
  const scrollEventHandler = useCallback(
    (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
      setScrollCoordinates(
        event.currentTarget.scrollLeft,
        event.currentTarget.scrollTop,
        event.currentTarget.offsetWidth,
      );
      if (scrollLeftRef.current === event.currentTarget.scrollLeft) return;
      // v1 via unstable actions void setWeekday(Math.floor(event.currentTarget.scrollLeft / (mwdWidthPerHour * 24)));
      void setWeekday(event.currentTarget.scrollLeft);
      scrollLeftRef.current = event.currentTarget.scrollLeft;
      if (showTooltip) {
        void setTooltipTimeoutId();
      }
    },
    [mwdWidthPerHour, showTooltip],
  );

  return {
    scrollEventHandler,
    mwdHeight,
    mwdWidth,
    mwdWidthPerHour,
  };
};
export default useMwdChart;
